import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import Notification from "../../elements/notification/Notification";
import BatchesList from "./BatchesList";
import { AppContext } from "../../../App";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBatchesWrapper } from "../styledBatches";
import BatchesFilter from "./BatchesFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const BatchesContainer = () => {
  const { t } = useTranslation("batchesPage");
  const [batches, setBatches] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const { user } = useContext(AppContext);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "createDate[gte]": checkFilterItem(history, "createDate[gte]", null, true),
    "createDate[lte]": checkFilterItem(history, "createDate[lte]", null, true),
    "startDate[gte]": checkFilterItem(history, "startDate[gte]", null, true),
    "startDate[lte]": checkFilterItem(history, "startDate[lte]", null, true),
    "status.value": checkFilterItem(history, "status.value", null),
    "name": checkFilterItem(history, "name", null),
    "user.nickname": checkFilterItem(history, "user.nickname", null),
    "user.email": checkFilterItem(history, "user.email", null),
    "processedAmount[gte]": checkFilterItem(history, "processedAmount[gte]", null, true),
    "processedAmount[lte]": checkFilterItem(history, "processedAmount[lte]", null, true),
    "amount[gte]": checkFilterItem(history, "amount[gte]", null, true),
    "amount[lte]": checkFilterItem(history, "amount[lte]", null, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "paymentSystem.name": checkFilterItem(history, "paymentSystem.name", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchBatches = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/batches" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setBatches(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  // TODO Add pusher

  // const updateBatch = (message) => {
  //   const data = JSON.parse(message.data);
  //   const index = batches.findIndex(item => item.id === data.id);
  //   if (index >= 0) {
  //     batches[index] = data;
  //     let newArr = [];
  //     setBatches([
  //       ...batches,
  //       ...newArr
  //     ]);
  //   }
  // };

  useEffect(() => {
    fetchBatches();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledBatchesWrapper>
          <div className="batches-head">
            <BatchesFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <BatchesList
            fetchBatches={fetchBatches}
            batches={batches}
          />
          {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
        </StyledBatchesWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default BatchesContainer;